import { STORAGE_KEYS } from '../constants/storage';
import { UserRole, QueueResponse } from '@/contexts/AppDataContext';
import { CallQueueType } from '@/constants/queue';

interface AccountInfo {
    name: string;
    username: string;
    tenantId: string;
}

export const getUserInfo = (): AccountInfo | null => {
    try {
        const accountInfo = localStorage.getItem(STORAGE_KEYS.ACCOUNT_INFO);
        return accountInfo ? JSON.parse(accountInfo) : null;
    } catch (error) {
        console.error('Error getting user info from localStorage:', error);
        return null;
    }
};

export const getUsername = (): string | null => {
    const userInfo = getUserInfo();
    return userInfo?.username || null;
};

export const getUserName = (): string | null => {
    const userInfo = getUserInfo();
    return userInfo?.name || null;
};

/**
 * Checks if user has permission to view Call Queue Insight section
 * @param userRole - Current user's role
 * @param queuesResponse - Array of queue responses
 * @returns true if user can view Call Queue Insight, false otherwise
 */
export const canViewCallQueueInsight = (
    userRole: UserRole,
    queuesResponse: QueueResponse[]
): boolean => {
    return (
        userRole === UserRole.ADMIN ||
        queuesResponse.length === 0 ||
        queuesResponse.some(q => q.type !== CallQueueType.DIRECT_AGENT_GROUP)
    );
};
